export enum AnalyticsAction {
  BC_get_started_now_video = 'BC_get_started_now_video',
  BC_get_started_now_banks = 'BC_get_started_now_banks',
  BC_explore_open_banking_apis = 'BC_explore_open_banking_apis',
  BC_explore_portal = 'BC_explore_portal',
  BC_explore_showcase = 'BC_explore_showcase',
  BC_contact_us = 'BC_contact_us',
  BC_sign_up_now = 'BC_sign_up_now',
  BC_header_showcase = 'BC_header_showcase',
  BC_header_apis = 'BC_header_apis',
  BC_header_contact_us = 'BC_header_contact_us',
  BC_header_get_started_now = 'BC_header_get_started_now',
  BC_load_dataset_request = 'BC_load_dataset_request',

  LC_header_apis = 'LC_header_apis',
  LC_header_showcase = 'LC_header_showcase',
  LC_header_contact_us = 'LC_header_contact_us',
  BC_bank_explore_showcase = 'BC_bank_explore_showcase',
  BC_bank_explore_api = 'BC_bank_explore_api',
  Page_bank_landing = 'Page_bank_landing_page',
  LC_api_portal = 'LC_api_portal',
  LC_about_us = 'LC_about_us',
  LC_contact_us = 'LC_contact_us',
  LC_faq = 'LC_faq',
  LC_terms_of_use = 'LC_terms_of_use',
  LC_privacy_policy = 'LC_privacy_policy',
  LC_header_app_studio = 'LC_header_app_studio',
}

export enum AnalyticsCategory {
  PAGE_GLOBAL_LANDING = 'Page_global_landing',
  PAGE_BANK_LANDING = 'Page_bank_landing',
  PAGE_API_LIST = 'Page_api_list',
  PAGE_DASHBOARD_MYDATA = 'Page_dashboard_mydata',
}
